export default __webpack_public_path__ + "static/media/Gopinath.8acb8112.png";